import React, { Suspense } from "react";
import PropTypes from "prop-types";

import Loading from "../Loading/Loading";

const SuspenseFallback = ({ children }) => (
  <Suspense fallback={<Loading />}>{children}</Suspense>
);

SuspenseFallback.propTypes = {
  children: PropTypes.element.isRequired,
};

export default SuspenseFallback;
